<template>
  <div>
    <top-bar heading="Dashboard"></top-bar>
    <div class="row container-fluid mt-3">
      <div class="col-12 col-lg-8">
        <b-card v-if="$auth.check('student')">
          <b-card-body>
            <loading-spinner :loading="!$store.state.studentCourses.length"></loading-spinner>
            <progression-charts :courses="$store.state.studentCourses"></progression-charts>
          </b-card-body>
        </b-card>

        <b-card header="Ungraded Submissions" v-if="$auth.check(['admin', 'super_admin', 'super_admin', 'rto', 'rto_trainer'])">
          <ungraded-submissions></ungraded-submissions>
        </b-card>

        <b-card header="My Submissions" v-if="$auth.check('student')">
          <student-submissions :user="$auth.user"></student-submissions>
        </b-card>

        <b-card header="Students" v-if="$auth.check(['employer', 'trainer'])">
          <my-users></my-users>
        </b-card>

        <b-card header="Worklogs" v-if="$auth.check('employer')">
          <work-logs-table></work-logs-table>
        </b-card>

        <b-card header="State Enrolments" v-if="$auth.check(['admin', 'super_admin', 'super_admin', 'rto', 'rto_trainer'])" class="d-sm-down-none">
          <state-enrolments></state-enrolments>
        </b-card>
      </div>

      <div class="col-12 col-lg-4">
        <b-card header="Notifications">
          <notifications></notifications>
        </b-card>

        <b-card header="Gender Enrolments" v-if="$auth.check(['admin', 'super_admin', 'super_admin', 'rto', 'rto_trainer'])" class="d-sm-down-none">
          <gender-enrolments></gender-enrolments>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import ProgressionCharts from '../components/ProgressionCharts';
import UsersCount from '../components/Dashboard/UsersCount';
import UngradedSubmissions from '../components/Dashboard/UngradedSubmissions';
import Notifications from '../components/Dashboard/NotificationsWidget';
import GenderEnrolments from '../components/Dashboard/GenderEnrolments';
import StateEnrolments from '../components/Dashboard/StateEnrolments';
import MyUsers from '../components/Dashboard/MyUsers';
import WorkLogsTable from '../components/Dashboard/WorkLogsTable';
import StudentSubmissions from '../components/Dashboard/StudentSubmissions';
import TopBar from '../components/TopBar';

export default {
  name: 'home',
  data () {
    return {
      statistics: {
        gender: {
          loaded: false
        },
        roles: {
          loaded: false
        },
        states: {
          loaded: false
        }
      }
    };
  },
  components: {
    TopBar,
    StudentSubmissions,
    WorkLogsTable,
    MyUsers,
    StateEnrolments,
    GenderEnrolments,
    Notifications,
    UngradedSubmissions,
    UsersCount,
    ProgressionCharts
  },
  methods: {

    loadStatistics () {},
    loadStates () {
      this.axios.get('/statistics/states').then(rsp => {
        const states = {};
        const statesRef = {
          1: 'ACT',
          2: 'NSW',
          3: 'NT',
          4: 'QLD',
          5: 'SA',
          6: 'TAS',
          7: 'VIC',
          8: 'WA'
        };
        for (let key of Object.keys(rsp.data)) {
          for (let stateKey of Object.keys(rsp.data[key].states)) {
            if (!Array.isArray(states[stateKey]))
              states[stateKey] = [statesRef[stateKey]]; // init array if not exists
            states[stateKey].push(rsp.data[key].states[stateKey]);
          }
        }
        // add totals
        for (let stateKey of Object.keys(states)) {
          const total = states[stateKey].reduce((sum, role) => {
            if (typeof role === 'number') sum += role;
            return sum;
          }, 0);
          states[stateKey].push(total);
        }
        this.statistics.states.data = states;
        this.statistics.states.loaded = true;
      });
    }
  },
  mounted () {
    if (this.$auth.check(['admin', 'super_admin', 'super_admin', 'rto', 'rto_trainer'])) {
      this.loadStatistics();
      this.loadStates();
    }
  },
  metaInfo: {
    title: 'Dashboard'
  }
};
</script>
